import React from "react";
import ATitle from "core/presentation/components/Title";
import DonutChart from "core/presentation/components/DoughnutChartComponent";
import { useAppSelector } from "core/presentation/store/hooks";

const OnTimeDeliveryRate: React.FC = () => {
  const { dashboardData } = useAppSelector((state) => state.user);
  const timeDeliveryData =
    dashboardData?.deliveryRate?.convertedDeliveryRateData;

  const totalDeliveries = timeDeliveryData?.onTime + timeDeliveryData?.delayed;

  let data;

  if (totalDeliveries === 0) {
    data = {
      labels: ["No Data"],
      datasets: [
        {
          data: [0.1],
          backgroundColor: ["#D3D3D3"],
          borderColor: "#ffffff",
          borderWidth: 2,
        },
      ],
    };
  } else {
    const onTimeDeliveryRate =
      (timeDeliveryData.onTime / totalDeliveries) * 100;
    const delayedDeliveryRate =
      (timeDeliveryData.delayed / totalDeliveries) * 100;

    data = {
      labels: ["Delayed", "On Time"],
      datasets: [
        {
          data: [delayedDeliveryRate, onTimeDeliveryRate],
          backgroundColor: ["#F3722C", "#98C971"],
          borderColor: "#ffffff",
          borderWidth: 2,
        },
      ],
    };
  }

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: totalDeliveries === 0 ? false : true,
      },
      datalabels: {
        display: totalDeliveries === 0 ? false : true,
        color: "#ffffff",
        font: {
          size: 12,
          weight: 500,
        },
        formatter: (value: any, context: any) => {
          return value + "%";
        },
      },
    },
    rotation: -90,
    circumference: 180,
    cutout: "60%",
    maintainAspectRatio: true,
    responsive: true,
    layout: {
      padding: {
        top: 20,
        bottom: 20,
      },
    },
  };
  return (
    <div
      style={{
        padding: "40px",
        border: "1px solid #EAECF0",
        margin: "20px 0",
        borderRadius: "8px",
        height: "90%",
        background: "#fff",
      }}
    >
      <ATitle
        content="On Time Delivery Rate"
        fontSize={16}
        fontWeight={600}
        marginTop="0"
        lineHeight={"20px"}
      />
      <DonutChart data={data} options={options} />
      {totalDeliveries ? (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            marginTop: 20,
          }}
        >
          <div style={{ display: "flex", marginRight: 15 }}>
            <div
              style={{
                width: 10,
                height: 10,
                backgroundColor: "#98C971",
                borderRadius: "50%",
                marginRight: 5,
              }}
            ></div>
            <span>On-Time</span>
          </div>
          <div style={{ display: "flex" }}>
            <div
              style={{
                width: 10,
                height: 10,
                backgroundColor: "#F3722C",
                borderRadius: "50%",
                marginRight: 5,
              }}
            ></div>
            <span>Delayed</span>
          </div>
        </div>
      ) : (
        <div style={{ display: "flex", marginRight: 15 }}>
          <div
            style={{
              width: 10,
              height: 10,
              backgroundColor: "#D3D3D3",
              borderRadius: "50%",
              marginRight: 5,
            }}
          ></div>
          <span>No Data Yet</span>
        </div>
      )}
    </div>
  );
};

export default OnTimeDeliveryRate;
